//@flow
import React from 'react';
import {PrimaryButton} from '@nike/ruxac';
import {connect} from 'react-redux';
import getProperty from 'lodash.get';
import {downloadExcel} from '../../data/modules/ui';
import {checkForToken} from '../../loginHelpers';

type Props = {
  uiMapping: Object,
  lineItemData: Object,
};

class DownloadExcel extends React.Component<Props> {
  render () {
    const {downloadExcel, sortBy} = this.props;
    return (
      <PrimaryButton
        onClick={() =>{
          const jwt = checkForToken ();
          downloadExcel(jwt.accessToken, sortBy);
        }
        }
      >
        <div>
          <i
            className="fa fa-file-excel-o fa-lg"
            style={{marginRight: '0.5em'}}
          />
          <span> Export to XLS </span>
        </div>
      </PrimaryButton>
    );
  }
}

const mapStateToProps = state => ({
  uiMapping: state.ui.cbdUIMapping,
  sortBy: state.ui.sortBy,
  lineItemData: getProperty (state.ui, ['data', 'cbdLineItems'], {}),
});
const mapDispatchToProps = {downloadExcel};

export default connect (mapStateToProps, mapDispatchToProps) (DownloadExcel);



// WEBPACK FOOTER //
// ./src/components/DownloadExcel/DownloadExcel.js